import type {
  ComponentValueResponse,
  OverrideQuizRequest,
  OverrideQuizResponse,
  QuizForInstance,
  StartQuizRequest,
  StartQuizResponse,
  SubmitQuizRequest,
  SubmitQuizResponse,
} from "@repo/shared/types";
import { get, post } from "../_client";

const BASE = "/internal/flow-instances";

export function getFlowInstanceValue(instanceId: string) {
  return get<ComponentValueResponse>(`${BASE}/${instanceId}/quiz/flow-instance-value`);
}

/** Score-stripped quiz definitions plus this client's standing on each. */
export function getQuizzes(instanceId: string) {
  return get<QuizForInstance[]>(`${BASE}/${instanceId}/quiz/quizzes`);
}

/** QL-505 — `subjectId` addresses one party when several answer (a group member, or a representative when 2+ are registered). */
export function startQuiz(instanceId: string, quizId: string, subjectId?: string) {
  return post<StartQuizResponse>(`${BASE}/${instanceId}/quiz/start`, {
    quizId,
    ...(subjectId ? { subjectId } : {}),
  } satisfies StartQuizRequest);
}

export function submitQuiz(instanceId: string, request: SubmitQuizRequest) {
  return post<SubmitQuizResponse>(
    `${BASE}/${instanceId}/quiz/submit`,
    request satisfies SubmitQuizRequest,
  );
}

/** Advisor-only — no public-flow counterpart by design. */
export function overrideQuiz(instanceId: string, request: OverrideQuizRequest) {
  return post<OverrideQuizResponse>(
    `${BASE}/${instanceId}/quiz/override`,
    request satisfies OverrideQuizRequest,
  );
}
